import SectionHeader from "@/components/SectionHeader";
import Reveal from "@/components/Reveal";
import { UserPlus, IdentificationCard, MagnifyingGlass, HandCoins, ChartLine } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import PageSEO from "@/components/PageSEO";

const STEPS = [
  { icon: UserPlus, title: "Create an Account", body: "Register in minutes with your basic details to unlock the Mayoto community." },
  { icon: IdentificationCard, title: "Complete Verification", body: "Our KYC-ready flow prepares your profile for participation in structured opportunities." },
  { icon: MagnifyingGlass, title: "Explore Opportunities", body: "Browse open opportunities across Real Estate, Agriculture and Strategic Investments." },
  { icon: HandCoins, title: "Select an Investment", body: "Choose an opportunity, review its terms and risk information, and confirm your participation." },
  { icon: ChartLine, title: "Track Your Investment", body: "Monitor progress, upcoming maturity dates and portfolio performance from your dashboard." },
];

export default function HowItWorks() {
  return (
    <div>
      <PageSEO
        title="How Mayoto Works – 5 Steps to Invest"
        description="Sign up, verify, explore opportunities, choose an investment and track your portfolio. Mayoto's five-step structured investment process — designed for Nigerian investors from NGN 2,000 upwards."
        canonicalPath="/how-it-works"
      />
      <section className="mayo-grain">
        <div className="container-wide py-20 lg:py-24">
          <p className="text-[#00b4d8] font-display font-bold tracking-[0.25em] text-xs">HOW IT WORKS</p>
          <h1 className="mt-4 font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[0.95] text-[#0a1128] max-w-3xl" data-testid="how-title">
            Five steps. Structured investing, made simple.
          </h1>
        </div>
      </section>

      <section className="py-24 bg-white">
        <div className="container-wide">
          <div className="relative">
            <div className="hidden lg:block absolute top-8 left-8 right-8 h-px bg-slate-200" />
            <div className="grid gap-8 lg:grid-cols-5">
              {STEPS.map((s, i) => (
                <Reveal key={s.title} delay={i * 100}>
                  <div className="relative">
                    <div className="h-16 w-16 rounded-2xl bg-[#0a1128] text-white grid place-items-center relative z-10">
                      <s.icon size={26} weight="bold" />
                    </div>
                    <p className="mt-2 font-display font-black text-3xl text-[#00b4d8]">{String(i + 1).padStart(2, "0")}</p>
                    <p className="mt-3 font-display font-bold text-lg text-[#0a1128]">{s.title}</p>
                    <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.body}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          <div className="mt-20 rounded-3xl mayo-navy-bg p-10 lg:p-16 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
            <div>
              <p className="text-[#d4af37] font-display font-bold tracking-[0.25em] text-xs">READY WHEN YOU ARE</p>
              <h2 className="mt-3 font-display font-bold text-3xl lg:text-4xl max-w-lg">Start your Mayoto investor journey today.</h2>
            </div>
            <div className="flex gap-3">
              <Link to="/register"><Button className="btn-shine bg-[#00b4d8] hover:bg-[#0096c7] rounded-full px-7 py-6 text-base">Create Account</Button></Link>
              <Link to="/investments"><Button variant="outline" className="rounded-full px-7 py-6 text-base border-white/40 text-white hover:bg-white/10">Explore Opportunities</Button></Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
